import React, { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { cn } from "@/lib/utils";
import {
  CommandInput,
  CommandEmpty,
  CommandList,
  CommandGroup,
  CommandItem,
  Command,
} from "../ui/command";
import { ChevronsUpDownIcon, Check, LoaderCircle, X } from "lucide-react";
import { Button } from "../ui/button";
import { Status } from "@/interfaces/Return";
import { getReturnStatus } from "@/services/return-status-list.service";

interface StatusSelectProps {
  selectedStatus: Status;
  setSelectedStatus: (status: Status) => void;
}

const StatusSelect: React.FC<StatusSelectProps> = ({
  selectedStatus,
  setSelectedStatus,
}) => {
  const [selectOpen, setSelectOpen] = useState(false);
  const [statusListLoading, setStatusListLoading] = useState(false);
  const [statusList, setStatusList] = useState<Status[]>([]);

  const getStatus = async () => {
    try {
      setStatusListLoading(true);
      const response = await getReturnStatus();
      console.log(response);
      if (response.status === 200) {
        setStatusList(response.data.data.list);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setStatusListLoading(false);
    }
  };

  const handleSelectItem = (status: Status) => {
    if (status.id === selectedStatus.id) {
      setSelectedStatus({} as Status);
    } else {
      setSelectedStatus(status);
    }
    setSelectOpen(false);
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <div className="grid gap-1 ">
        <label className="text-sm font-medium" htmlFor="supplier">
          Statut
        </label>
      </div>
      <div className="flex items-center justify-between gap-2 w-full">
        <Popover open={selectOpen} onOpenChange={setSelectOpen}>
          <PopoverTrigger asChild>
            <div className="flex items-center gap-2 w-full">
              <Button
                className="w-full justify-between "
                role="combobox"
                variant="outline"
              >
                {selectedStatus.name && selectedStatus
                  ? selectedStatus.name
                  : "Choisir un statut"}
                <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
              </Button>
              {selectedStatus.id && (
                <Button
                  variant="outline"
                  onClick={() => setSelectedStatus({} as Status)}
                >
                  <X className="w-4 h-4" />
                </Button>
              )}
            </div>
          </PopoverTrigger>

          <PopoverContent className="w-[--radix-popover-trigger-width] max-h-[--radix-popover-content-available-height]">
            <Command>
              <CommandInput className="h-9" placeholder="Chercher un statut" />
              <CommandEmpty>Aucun fournisseur trouvé</CommandEmpty>
              <CommandList>
                <CommandGroup>
                  {statusList &&
                    statusList.map((status) => (
                      <CommandItem
                        key={status.id}
                        value={status.name}
                        onSelect={() => {
                          handleSelectItem(status);
                        }}
                      >
                        <Check
                          className={cn(
                            "mr-2 h-4 w-4",
                            status.id === selectedStatus.id
                              ? "opacity-100"
                              : "opacity-0"
                          )}
                        />
                        {status.name}
                      </CommandItem>
                    ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        {statusListLoading && (
          <LoaderCircle className="animate-spin" color="grey" size={20} />
        )}
      </div>
    </div>
  );
};

export default StatusSelect;
